import Evaporator from "./Evaporator.json";
import Condenser from "./Condenser.json";

export default (type) => {
  switch (type) {
    case "Evaporator":
      return Evaporator;
    case "Condenser":
      return Condenser;
    default:
      return [];
  }
};
